import { render, staticRenderFns } from "./MiniviewOption.vue?vue&type=template&id=2b1aea30"
import script from "./MiniviewOption.vue?vue&type=script&lang=js"
export * from "./MiniviewOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports